export default __webpack_public_path__ + "static/media/epq-logo.f0802f09.svg";